(() => {
  'use strict';
  const root = document.querySelector('.kp-discovery');
  if (!root) return;
  const nav = root.querySelector('.kp-cd-page-nav');
  const header = document.querySelector('.kp-header');
  const measure = () => {
    const height = header?.getBoundingClientRect().height || 0;
    const padding = parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;
    root.style.setProperty('--kp-cd-header', `${height}px`);
    root.style.setProperty('--kp-cd-anchor', `${Math.max(0, height + (nav?.offsetHeight || 0) - padding + 16)}px`);
  };
  measure();
  if ('ResizeObserver' in window) {
    const observer = new ResizeObserver(measure);
    if (header) observer.observe(header);
    if (nav) observer.observe(nav);
  }
  const strainTools = root.querySelector('[data-strain-tools]');
  if (strainTools) {
    const cards = [...root.querySelectorAll('[data-collection-grid] > [data-product-card]')];
    const search = strainTools.querySelector('[data-strain-search]');
    const buttons = [...strainTools.querySelectorAll('[data-strain-shade]')];
    const status = root.querySelector('[data-strain-status]');
    const empty = root.querySelector('[data-strain-empty]');
    let shade = 'all';
    const update = () => {
      const term = search.value.trim().toLocaleLowerCase();
      let visible = 0;
      cards.forEach(card => {
        const name = card.querySelector('h3')?.textContent.toLocaleLowerCase() || '';
        card.hidden = !((shade === 'all' || card.classList.contains(`kp-card--${shade}`)) && name.includes(term));
        if (!card.hidden) visible++;
      });
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.strainShade === shade)));
      status.textContent = `${visible} of ${cards.length} strains shown`;
      status.hidden = !term && shade === 'all';
      empty.hidden = visible !== 0;
    };
    buttons.forEach(button => button.addEventListener('click', () => { shade = button.dataset.strainShade; update(); }));
    search.addEventListener('input', update);
    root.querySelector('[data-strain-reset]')?.addEventListener('click', () => { shade = 'all'; search.value = ''; update(); search.focus(); });
    strainTools.hidden = false;
  }
  const commerce = window.KPCommerce;
  if (commerce) root.querySelectorAll('[data-collection-price-product]').forEach(script => {
    try {
      const product = JSON.parse(script.textContent);
      product.variants.forEach(variant => {
        const cell = root.querySelector(`[data-collection-price-row="${variant.id}"] [data-collection-unit]`);
        const unit = commerce.units(variant, product.handle);
        if (cell && unit) cell.textContent = `${commerce.unitMoney(variant.price / unit.count)} / ${unit.unit}`;
      });
    } catch { /* Pack prices and direct variant links remain available without unit enhancement. */ }
  });
})();
